import { render } from "./SiteBrand.vue?vue&type=template&id=009d62f4"
import script from "./SiteBrand.vue?vue&type=script&lang=js"
export * from "./SiteBrand.vue?vue&type=script&lang=js"
script.render = render

export default script